export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7744.3c912d75.jpg";